import { Component, OnInit } from '@angular/core';
import { Router, Event, NavigationEnd, NavigationStart } from '@angular/router';
import { State } from './reducers';
import { Store } from '@ngrx/store';
import {
  putChangeUrgencyWritersList,
  putChangeUrgencyBookList,
  useAdvancedSearchParameters,
  setBookFormValues,
} from './actions/writers.actions';
import { LocationPath } from './enums';
import { Subscription } from 'rxjs';
import { SearchService } from './search.service';
import { ScrollService } from './scroll.service';
import { FirebaseService } from './firebase.service';
import { SwUpdate } from '@angular/service-worker';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = "Ashuris";
  routerNavigation$Subscription: Subscription;
  previousUrl: string;
  showPermissionDialog = false;
  permissionDialogTitle = 'הרשאות נדרשות';
  permissionDialogMessage = 'האפליקציה צריכה גישה למצלמה כדי לצלם תמונות. האם ברצונך לאפשר גישה?';

  constructor(
    private router: Router,
    private store: Store<State>,
    private searchService: SearchService,
    private scrollService: ScrollService,
    public firebaseService: FirebaseService,
    private swUpdate: SwUpdate,
  ) { }

  get imageToUploads() {
    return 'info?.doc_count'
  }

  async checkAndRequestPermissions() {
    try {
      const result = await navigator.permissions.query({ name: 'camera' as PermissionName });
      if (result.state === 'prompt') {
        this.showPermissionDialog = true;
      } else if (result.state === 'denied') {
        // If already denied, try to open settings directly
        this.openDeviceSettings();
      }
    } catch (err) {
      console.error('Error checking permissions:', err);
    }
  }

  async onPermissionDialogConfirm() {
    this.showPermissionDialog = false;
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      stream.getTracks().forEach(track => track.stop());
    } catch (err) {
      await this.openDeviceSettings();
    }
  }

  private async openDeviceSettings() {
    if ('openSettings' in navigator.permissions) {
      const permissions = navigator.permissions as { openSettings: () => Promise<void> };
      await permissions.openSettings();
    } else if ('xr' in navigator && 'permissions' in navigator) {
      window.location.href = 'app-settings:';
    } else {
      window.open('app-settings:', '_system');
    }
  }

  onPermissionDialogCancel() {
    this.showPermissionDialog = false;
  }

  ngOnInit() {
    // Check permissions when app starts
    this.checkAndRequestPermissions();

    if (this.swUpdate.isEnabled) {
      console.log('Service Worker update is enabled.');
      this.swUpdate.checkForUpdate().then((available: boolean) => {
      console.log('Check for update completed. Update available:', available);
      if (available) {
        this.swUpdate.activateUpdate().then(() => {
        console.log('Update activated.');
        if (confirm('New version of the app is available. Load New Version?')) {
          console.log('User confirmed to load new version.');
          document.location.reload();
        } else {
          console.log('User declined to load new version.');
        }
        }).catch(err => {
        console.error('Error activating update:', err);
        });
      } else {
        console.log('No update available.');
      }
      }).catch(err => {
      console.error('Error checking for update:', err);
      });
    } else {
      console.log('Service Worker update is not enabled.');
    }
    this.routerNavigation$Subscription = this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        this.scrollService.setLastScrollPosition()
      }
      if (event instanceof NavigationEnd) {
        this.scrollService.scrollToTop();
        if (
          this.previousUrl === '/writers-list-screen' ||
          this.previousUrl === '/search-result' ||
          this.previousUrl === '/writer-reminders'
        ) {
          this.store.dispatch(putChangeUrgencyWritersList());
        } else if (
          this.previousUrl === '/book-list-screen' ||
          this.previousUrl === '/book-reminders' ||
          this.previousUrl === LocationPath.DEALER_BOOK_LIST
        ) {
          this.store.dispatch(putChangeUrgencyBookList());
        } else if ((event.urlAfterRedirects === '/writers-list-screen') && (this.previousUrl !== '/')) {
          localStorage.setItem('UseWriterListFilterParams', 'true');
        } else if ((event.urlAfterRedirects === '/writers-list-screen') && (this.previousUrl === '/')) {
          localStorage.setItem('writerListFilterParams', '{}');
        }
        if ((event.urlAfterRedirects === '/writers-advanced-search') && (this.previousUrl === '/search-result')) {
          this.store.dispatch(useAdvancedSearchParameters({ boolean: true }));
        }
        if (
          (
            (event.urlAfterRedirects === LocationPath.WRITERS_ADVANCED_SEARCH)
            ||
            (event.urlAfterRedirects === LocationPath.BOOKS_ADVANCED_SEARCH)
            ||
            (event.urlAfterRedirects === LocationPath.CREATE_BOOK)
          )
          &&
          (this.previousUrl === '/')
        ) {
          this.store.dispatch(setBookFormValues({ form: null }));
          this.searchService.clearAdvancedSearchParameters();
        }
        this.previousUrl = event.urlAfterRedirects;
      }
    });
  }

}
